<!-- 汇率维护 -->
<template>
  <div class="monthCashBalanceAdd">
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button @click="save()" type="primary" class="vxe-btn-primary">{{
          $t('monthCashBalance.button.save')
        }}</vxe-button>
        <vxe-button
          @click="insertEvent()"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >{{ $t('monthCashBalance.button.add') }}</vxe-button
        >
        <vxe-button
          @click="handleDelete()"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >{{ $t('monthCashBalance.button.delete') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
      :edit-rules="rules"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      @edit-actived="editActivedEvent"
    >
    </vxe-grid>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { addRules } from './rules.js'; // 校验规则
  import API from '@/api/capitalCenter/moneyDraw';
  // import InputNumber from '@/components/form-item/input-number';
  export default {
    name: 'monthCashBalanceAdd',
    components: {
      // InputNumber,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      //基础数据表单配置
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            field: 'businessCompanyCode',
            title: this.$t('monthCashBalance.column.businessCompany'),
            editRender: {
              name: 'ElSelect',
              options: this.companyList,
              props: {
                clearable: true,
                filterable: true,
              },
              events: { change: this.companyChange },
            },
          },
          {
            field: 'businessDepartmentCode',
            title: this.$t('monthCashBalance.column.businessDepartment'),
            formatter: this.formatDepartLabel,
            editRender: {
              name: 'ElSelect',
              options: this.departmentList,
              props: {
                clearable: true,
                filterable: true,
              },
              events: { change: this.departmentChange },
            },
          },
          {
            field: 'fundYear',
            title: this.$t('monthCashBalance.column.fundYear'),
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                type: 'year',
                valueFormat: 'yyyy',
              },
            },
          },
          {
            field: 'fundMonth',
            title: this.$t('monthCashBalance.column.fundMonth'),
            editRender: {
              name: 'ElSelect',
              options: this.monthList,
              props: {
                clearable: true,
                filterable: true,
              },
            },
          },
          {
            field: 'fundBalanceBeginning',
            title: this.$t('monthCashBalance.column.fundBalanceBeginning'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.fundBalanceBeginning}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.fundBalanceBeginning}
                    max={999999999.999999}
                    min={-999999999}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'fundBalanceBeginning')}
                  ></input-number>,
                ];
              },
            },
          },
        ];
      },
    },
    data() {
      return {
        companyList: [],
        departmentList: [],
        tableData: [], // 表格数据
        rules: addRules, // 校验规则
        monthList: [
          { label: '一月', value: 1 },
          { label: '二月', value: 2 },
          { label: '三月', value: 3 },
          { label: '四月', value: 4 },
          { label: '五月', value: 5 },
          { label: '六月', value: 6 },
          { label: '七月', value: 7 },
          { label: '八月', value: 8 },
          { label: '九月', value: 9 },
          { label: '十月', value: 10 },
          { label: '十一月', value: 11 },
          { label: '十二月', value: 12 },
        ],
        addRowObj: {
          businessCompanyCode: '',
          businessCompanyName: '',
          businessDepartmentCode: '',
          businessDepartmentName: '',
          fundYear: '',
          fundMonth: '',
          fundBalanceBeginning: '',
        },
      };
    },
    mounted() {
      this.resolveTableData(); // 初始五行表格空数据
      this.getCompany();
    },
    methods: {
      chooseTable(val, row, prop) {
        row[prop] = val;
      },
      //公司代码
      async getCompany() {
        let res = await this.$baseRequest.getCompanyList();
        if (res) {
          this.companyList = res;
        }
      },
      companyChange(val) {
        val.row.businessCompanyName = val.row.businessCompanyCode
          ? this.companyList.find((item) => item.value == val.row.businessCompanyCode).label
          : null;
        val.row.businessDepartmentCode = null;
        this.getDepartment(val.row.businessCompanyCode);
      },
      async getDepartment(companyCode) {
        if (companyCode) {
          let res = await this.$baseRequest.getDepartment(companyCode);
          if (res) {
            this.departmentList = res;
          }
        } else {
          this.departmentList = [];
        }
      },
      departmentChange(val) {
        val.row.businessDepartmentName = this.departmentList.find(
          (item) => item.value == val.row.businessDepartmentCode
        ).label;
      },
      formatDepartLabel({ row }) {
        return row.businessDepartmentName ? row.businessDepartmentName : '';
      },
      editActivedEvent({ row }) {
        if (row.businessCompanyCode) {
          this.getDepartment(row.businessCompanyCode);
        } else {
          this.departmentList = [];
        }
      },
      // 表格新增一行
      insertEvent(row) {
        this.$refs.table.validate((valid) => {
          if (valid) {
            let record = {
              businessCompanyCode: '',
              businessCompanyName: '',
              businessDepartmentCode: '',
              businessDepartmentName: '',
              fundYear: '',
              fundMonth: '',
              fundBalanceBeginning: '',
            };
            this.$refs.table.insertAt(record, row).then(({ row }) => {
              this.$refs.table.setActiveRow(row);
            });
          }
        });
      },
      // 表格删除
      handleDelete() {
        const selectedList = this.$refs.table.getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('monthCashBalance.msg.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            selectedList.map((item) => {
              if (item.id) {
                this.del.push(item.id);
              }
            });
            this.$refs.table.removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('monthCashBalance.msg.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('monthCashBalance.msg.cancelled'),
            });
          });
      },
      async save() {
        let res = await this.exportChildData();
        if (res) {
          let params = {
            ...res,
          };
          this.saveData(params);
        }
      },
      async saveData(params) {
        this.loading.startLoading();
        let res = await this.$axios.post(API.SAVE_CASHBALANCE, params);
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: res.data.msg,
            });
            this.returnListPage();
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        }
      },
      // 初始五行表格空数据
      resolveTableData() {
        for (var i = 0; i < 1; i++) {
          this.tableData.push(JSON.parse(JSON.stringify(this.addRowObj)));
        }
      },
      // 返回列表页
      returnListPage() {
        let path = {
          fromPath: {
            path: '/moneyDraw/monthCashBalanceAdd',
            name: 'monthCashBalanceAdd',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/moneyDraw/monthCashBalanceList',
            name: 'monthCashBalanceList',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      // 返回数据
      exportChildData() {
        const tableData = this.$refs.table.getTableData().fullData;
        return new Promise((resolve) => {
          this.$refs.table.validate((valid) => {
            if (valid) {
              let param = {
                list: tableData,
              };
              resolve(param);
            }
          });
        });
      },
    },
  };
</script>

<style scoped></style>
